import { render, staticRenderFns } from "./ReviewsListTable.vue?vue&type=template&id=b652ff3c&scoped=true"
import script from "./ReviewsListTable.vue?vue&type=script&lang=js"
export * from "./ReviewsListTable.vue?vue&type=script&lang=js"
import style0 from "./ReviewsListTable.vue?vue&type=style&index=0&id=b652ff3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b652ff3c",
  null
  
)

export default component.exports